import cn from 'clsx'
import { Button, IconButton, UserAddedIcon, UserAddIcon } from '@ds/components'

import type { TFollowButtonProps } from './FollowButton.types'
import styles from './FollowButton.module.css'

export const FollowButton = ({
    as = 'button',
    label,
    isFollowing,
    loading,
    disabled,
    hideMobileText,
    size = 'small',
    showOnlySecondaryVariant,
    onClick,
}: TFollowButtonProps) => {
    const followStatus = isFollowing ? 'following' : 'not-following'
    const Icon = isFollowing ? UserAddedIcon : UserAddIcon

    if (as === 'action') {
        return (
            <IconButton
                variant="outline"
                size={isFollowing ? 'icon' : 'labeled'}
                Icon={Icon}
                aria-label={label}
                data-test="audio-action-follow"
                disabled={disabled}
                onClick={onClick}
            >
                {isFollowing ? null : label}
            </IconButton>
        )
    }

    return (
        <Button
            variant={showOnlySecondaryVariant || isFollowing ? 'secondary' : 'primary'}
            size={size}
            LeftIcon={Icon}
            loading={loading}
            disabled={disabled}
            hideMobileText={hideMobileText}
            className={cn(styles.followButton, hideMobileText && styles.followButtonNarrow)}
            onClick={onClick}
            data-test="follow-button"
            data-test-status={followStatus}
        >
            <p>{label}</p>
        </Button>
    )
}
